/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The bank account type.
 */
export const BankAccountType = {
  Checking: "checking",
  Savings: "savings",
  GeneralLedger: "general-ledger",
  Loan: "loan",
} as const;
/**
 * The bank account type.
 */
export type BankAccountType = ClosedEnum<typeof BankAccountType>;

/** @internal */
export const BankAccountType$inboundSchema: z.ZodNativeEnum<
  typeof BankAccountType
> = z.nativeEnum(BankAccountType);
/** @internal */
export const BankAccountType$outboundSchema: z.ZodNativeEnum<
  typeof BankAccountType
> = BankAccountType$inboundSchema;
